import React, {useMemo} from "react";
import MantineInputField from "./MantineInputField";
import {CreditCardField} from "./CreditCardField";
import MantineSelectField from "./MantineSelectField";
import validateRequired from "./utils/validateRequired";
import {Grid} from "@mantine/core";

const TarjetaCreditoFields = ({formField, extraFieldsNames = [], marcas = []}) => {
    const {marcaTarjeta, numeroTarjeta} = formField;
    const extraFieldsRender = useMemo(() => extraFieldsNames.map((field) => {
        switch (field) {
            case "titularTarjeta":
                return (
                    <MantineInputField
                        name={`infoDePago.titularTarjeta`}
                        label='Nombre del titular'
                        forceUpperCase
                        withAsterisk
                        isRequired
                    />
                );
            case "vencimiento":
                return (
                    <CreditCardField
                        name='infoDePago.fechaVencimientoTarjeta'
                        label='Fecha de vencimiento'
                        isRequired
                        validation={
                            (value) => {
                                let error = validateRequired(value);
                                if (error) return error;

                                const [month, year] = value.split('/');
                                const currentYear = new Date().getFullYear();
                                const currentMonth = new Date().getMonth();
                                const expirationYear = parseInt(year);
                                const expirationMonth = parseInt(month);
                                error = expirationYear < currentYear || (expirationYear === currentYear && expirationMonth <= currentMonth) ? 'Ingrese una fecha de vencimiento válida' : null;
                                return error;
                            }
                        }
                    />
                );
        }
    }), []);

    return (
        <>
            <Grid.Col xs={12} sm={6}>
            <MantineSelectField
                name={`infoDePago.${marcaTarjeta.name}`}
                label={marcaTarjeta.label}
                data={marcas}
                withAsterisk
            />
            </Grid.Col>
            <Grid.Col xs={12} sm={6}>
            <MantineInputField
                name={`infoDePago.${numeroTarjeta.name}`}
                label={numeroTarjeta.label}
                withAsterisk
            />
            </Grid.Col>
            <Grid.Col xs={12} sm={6}>
            {extraFieldsRender}
            </Grid.Col>
        </>
    );
}

export default TarjetaCreditoFields;